import $ from 'jquery'

const toggleClear = ($wrap) => {
  const $input = $wrap
    .find('input[type="text"], input[type="search"], input:not([type])')
    .first();
  const $clear = $wrap.find(".clear__header-input").first();

  if (!$input.length || !$clear.length) return;

  const hasValue = ($input.val() || "").trim().length > 0;
  $clear.toggle(hasValue);
};

// изначально скрываем крестики (на случай prefilled значения — сразу включим где нужно)
$(".clear__header-input").hide();
$(".clear__header-input").each(function () {
  toggleClear($(this).closest(".flex"));
});

// следим за вводом (input ловит и paste, и backspace)
$(document).on(
  "input",
  'input[name="search"], input[type="search"], input[data-clearable]',
  function () {
    toggleClear($(this).closest(".flex"));
  },
);

// клик по крестику: чистим ближайший инпут и триггерим input
$(document).on("click", ".clear__header-input", function () {
  const $wrap = $(this).closest(".flex");
  const $input = $wrap
    .find('input[type="text"], input[type="search"], input:not([type])')
    .first();

  $input.val("").trigger("input").focus();
});

export function cutTheText(el, text, more = true) {
  const fullString = text;
  if (text.length - 200 < 20) {
    return text;
  }
  const cutString = text.substring(0, 200) + "...";
  const btn = jQuery("<span>", {
    class:
      "ms-3 fw-medium text-green cursor-pointer ws-nowrap d-inline-flex align-items-center",
    click: function () {
      cutTheText(el, fullString);
    },
  });

  if ($(el).hasClass("cut")) {
    btn.html("Свернуть");
    $(el).removeClass("cut").text(fullString);
  } else {
    btn.html(`
          <span class="me-2">
            Показать все
          </span>
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.5 12.75L10.935 8.99939L7.5 5.25" stroke="#2E695D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        `);
    $(el).addClass("cut").text(cutString);
  }
  if (more) {
    $(el).append(btn);
  }
}

export function isMobile() {
  if (window.innerWidth < 1040) {
    return true;
  }

  return false;
}

export function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file); // важно!
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

export function fixFilePath(path) {
  let newPath = "";

  if (path[0] === "/") {
    newPath = "/upload/zakaz" + path;
  } else {
    newPath = "/upload/zakaz/" + path;
  }

  return newPath;
}

export function isValidDate(date) {
  return date instanceof Date && !isNaN(date);
}
